'use client';

import { Box, Link, Typography } from '@coolblue-development/freddy';
import selectAlternativeProductTrigger from '@coolblue-development/ga4-events/triggers/ProductInformation/selectAlternativeProductTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';

export default function BetterProductLink({
  con,
  betterProductUrl,
  linkTitle,
  totalIndices,
  index,
  betterProductId
}: {
  con: string;
  betterProductUrl: string;
  linkTitle: string;
  totalIndices: number;
  index: number;
  betterProductId: number;
}) {
  const { trackEvent } = useAnalytics();
  const params = {
    index: index + 1,
    total_indices: totalIndices,
    method: 'link' as 'image' | 'link' | 'title',
    item_id: betterProductId
  };

  return (
    <Box>
      <Typography display='inline'>{con} </Typography>
      <Link
        href={betterProductUrl}
        onClick={() => trackEvent(selectAlternativeProductTrigger(params))}
      >
        {linkTitle}
      </Link>
    </Box>
  );
}
